import React from 'react';
import Immutable from 'immutable';
import c from 'classnames';

import { Image, Button } from '../../../components';

import './style.scss';

const ParagraphExtendedLink = ({ entity, className }) => {
  if (!entity) {
    return null;
  }

  const links = entity.get('field_link');
  const description = entity.getIn(['field_link_description', 0, 'value']);
  const illustration = entity.getIn(['field_illustration', 0]);

  const isExternalLink = links?.getIn([0, 'options', 'external']);

  return (
    <div className="Paragraph paragraph--type--extended-link paragraphExtendedLink d-flex">
      {illustration && (
        <div class="paragraph--type--extended-link__illustration">
          <Image
            src={illustration.get('source')}
            alt={illustration.get('title') || ''}
          />
        </div>
      )}

      <div class="paragraph--type--extended-link__link-text">
        {links?.map((field) => {
          const href = field.get('alias') || field.get('uri');
          const title = field.get('title');

          return (
            <Button
              key={href}
              href={href}
              type="link"
            >
              {title}
            </Button>
          );
        })}

        <div class="paragraph--type--extended-link__link-text__text" data-is-external-link={!!isExternalLink}>
          {description}
        </div>
      </div>
    </div>
  );
};

export default ParagraphExtendedLink;